export interface PaginationQuery {
  page: number
  limit: number
}

export const getPaginationQuery = (paginationQuery: PaginationQuery): string =>
  `page=${paginationQuery.page}&limit=${paginationQuery.limit}`
